import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import CategoryType from 'owa-service/lib/contract/CategoryType';

export default function getMasterCategoryList(): CategoryType[] {
    let masterCategoryList = getUserConfiguration().MasterCategoryList;

    // the MasterCategoryList can be null for shared mailboxes
    return (masterCategoryList && masterCategoryList.MasterList) || [];
}
